import React from 'react';
import PropTypes from 'prop-types';

export default function SubmissionFieldDefault({
  context,
  question,
  value = '',
}) {
  return value || '';
}

SubmissionFieldDefault.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
};
